import React from 'react';

/*
 * Champ de recherche partagé par le portail et les écrans d'administration.
 *
 * Son apparence vit dans global.css (.search-field) et non en style inline :
 * ni :hover ni :focus ne s'expriment en inline, et un style inline
 * l'emporterait de toute façon sur eux.
 */
export default function SearchField({
  value,
  onChange,
  placeholder = 'Rechercher...',
  inputRef,
  showShortcut = false,
  className = '',
}) {
  const vider = () => { onChange(''); inputRef?.current?.focus(); };

  return (
    <div className={`search-field ${className}`.trim()}>
      <span className="search-field-icon" aria-hidden="true">🔍</span>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Escape') onChange(''); }}
        placeholder={placeholder}
        aria-label={placeholder}
        autoComplete="off"
      />
      {value ? (
        <button
          type="button"
          className="search-field-clear"
          onClick={vider}
          title="Effacer la recherche"
          aria-label="Effacer la recherche"
        >
          ✕
        </button>
      ) : showShortcut ? (
        <span className="search-field-hint" aria-hidden="true">/</span>
      ) : null}
    </div>
  );
}
